import * as React from 'react';

import { IconPropsType } from 'designSystem/types/icons';

interface ICloseIconProps extends IconPropsType {}

const CloseIcon = ({
  size = 32,
  stroke = '#ffffff',
  strokeWidth = '2',
  ...props
}: ICloseIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.5 8L8.5 24"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 8L24.5 24"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default CloseIcon;
